import React, { Component, Fragment } from "react";

class ShortEnrollmentDownload extends Component {
    componentDidMount() {
        if (document.getElementById("fill-out-form-directions")) {
            let directions = document.getElementById(
                "fill-out-form-directions"
            );
            directions.style.display = "none";
        }
    }

    render() {
        const { pdfUrl } = this.props;

        return (
            <Fragment>
                {/*<p className="submitted">
                    You have successfully submitted the enrollment form. A
                    dedicated Care Coordinator will contact you to provide more
                    information.
                </p>*/}
                <p className="submitted">
                    Download a copy of your completed enrollment form to save
                    for your records.
                </p>
                <div className="grid">
                    <div className="row">
                        <div className="col-md-12">
                            <a
                                id="pc-enrollment-download-pdf-form"
                                href={pdfUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button blue button-spacing"
                            >
                                DOWNLOAD (
                                <i
                                    className="fa fa-file-pdf-o"
                                    aria-hidden="true"
                                ></i>{" "}
                                PDF)
                            </a>
                        </div>
                        <div className="col-md-12">
                            <a href="/nuplazid/patient-caregivers">
                                Return to homepage
                            </a>
                        </div>
                    </div>
                </div>
                <div className="row spacer-small">&nbsp;</div>
                <div className="row spacer-small">&nbsp;</div>
                <div className="row spacer-small mobile">&nbsp;</div>
                <div className="row spacer-small mobile">&nbsp;</div>
                {/* <div class="container-fluid">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h3 class="copy-blue">
                                    <span class="underline">
                                        what to expect
                                    </span>{" "}
                                    when you're enrolled
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row spacer-medium desktop">&nbsp;</div>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="card">
                                    <div class="card-body">
                                        <h1 class="card-title hang-left-8">
                                            1
                                        </h1>
                                        <p
                                            class="card-text"
                                            style="font-size: 16px !important;"
                                        >
                                            YOUR CARE COORDINATOR{" "}
                                            <span class="nobr">WILL CALL</span>
                                        </p>
                                        <p>
                                            Your Care Coordinator will reach out
                                            to learn more about your situation
                                            and discuss how they can help.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card">
                                    <div class="card-body">
                                        <h1 class="card-title hang-left-4">
                                            2
                                        </h1>
                                        <p class="card-text">
                                            YOUR PHARMACY{" "}
                                            <span class="nobr">WILL CALL</span>
                                        </p>
                                        <p>
                                            They will finalize your prescription
                                            details and schedule delivery so you
                                            or the person you care for can get
                                            started on therapy right away.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card">
                                    <div class="card-body">
                                        <h1 class="card-title hang-left-2">
                                            3
                                        </h1>
                                        <p class="card-text">
                                            YOUR PRESCRIPTION{" "}
                                            <span class="nobr">WILL BE</span>{" "}
                                            DELIVERED
                                        </p>
                                        <p>
                                            After the initial delivery, your
                                            pharmacy will contact you to confirm
                                            refills and delivery every month.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card">
                                    <div class="card-body">
                                        <h1 class="card-title hang-left-1">
                                            4
                                        </h1>
                                        <p class="card-text">
                                            YOUR ONGOING SUPPORT BEGINS
                                        </p>
                                        <p>
                                            Your Care Coordinator will regularly
                                            contact you to check in and help
                                            with any changes to your insurance,
                                            financial situation, or prescription
                                            delivery.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div class="row">
                    <div class="col">
                        <h3>
                            Please visit{" "}
                            <a
                                className="teal"
                                href="https://nuplazid.com"
                                target="_blank"
                            >
                                NUPLAZID.com
                            </a>{" "}
                            for more information.
                        </h3>
                        <div class="row spacer-small desktop">&nbsp;</div>
                        <p>
                            Please read full{" "}
                            <a
                                href="https://nuplazid.com/pdf/nuplazid-prescribing-information.pdf"
                                target="_blank"
                            >
                                Prescribing Information
                            </a>
                            , including <b>Boxed WARNING</b>.
                        </p>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default ShortEnrollmentDownload;
